<template>
    <UtilitiesWebView url="/city-tours" />
</template>
